module.exports = __webpack_public_path__ + "assets/60e8ec37bca3e4f1cdc8711027db937e.mp3";